module.exports = __webpack_public_path__ + "media/images/new-image-0c152a8b73c3001155efb2c61f9a5574.png";